export const OPEN_NAV = 'OPEN_NAV';
export const SHOW_SERVICES = 'SHOW_SERVICES';
export const SHOW_PROJECTS = 'SHOW_PROJECTS';
export const HANDLE_CLOSE = 'HANDLE_CLOSE';
export const SET_HEIGHT = 'SET_HEIGHT';
